import request from './request'
import * as http from '@/libs/http'

/**
 * 予約情報を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Number} rid 予約ID
 * @param {Object} reserve 予約情報
 * @returns {Response} レスポンスデータ
 */
export function putReserve (uid, rid, reserve) {
  return request.put(`/users/${uid}/reserves/${rid}`, reserve, {
    validateStatus: (status) => [
      http.OK,
      http.Conflict,
      http.BadRequest
    ].includes(status)
  })
}
